import { Pipe, PipeTransform } from '@angular/core';

import { DealerAssistTableErrorCode } from '../models/communication/baccarat-enums.model';

@Pipe({
    name: 'errorCode',
    standalone: true
})
export class ErrorCodePipe implements PipeTransform {
    transform(value: string, ..._args: unknown[]): string {
        return ErrorCodePipe.stringToDescription(value);
    }

    static stringToDescription(value: string): string {
        switch (value as DealerAssistTableErrorCode) {
            case DealerAssistTableErrorCode.BackendDisconnected:
                return $localize`Backend disconnected`;
            case DealerAssistTableErrorCode.RoundOpeningFailed:
                return $localize`Round opening failed`;
            case DealerAssistTableErrorCode.RoundResultSavingFailed:
                return $localize`Round result saving failed`;
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown error code: ${value}`);
                return value;
        }
    }
}
